// src/components/SegmentTabs.js
import React, { useState, useRef } from "react";


export default function SegmentTabs({ active, onChange }) {
  const scrollRef = useRef(null);
  const segments = [
    { key: "default", label: "ALL" },
    { key: "img", label: "IMG" },
    { key: "vid", label: "VID" },
    { key: "aud", label: "AUD" },
    { key: "text", label: "TEXT" },
    { key: "trends", label: "TRENDS" },
    { key: "memes", label: "MEMES" },
    { key: "fun", label: "FUN" },
    { key: "shorts", label: "SHORTS" },
  ];

  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const mouseDown = (e) => {
    scrollRef.current.classList.add("dragging");
    startX.current = e.pageX - scrollRef.current.offsetLeft;
    scrollLeft.current = scrollRef.current.scrollLeft;
  };

  const mouseLeave = () => scrollRef.current.classList.remove("dragging");
  const mouseUp = () => scrollRef.current.classList.remove("dragging");

  const mouseMove = (e) => {
    if (!scrollRef.current.classList.contains("dragging")) return;
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX.current) * 2;
    scrollRef.current.scrollLeft = scrollLeft.current - walk;
  };

  return (
    <div
      className="segment-tabs"
      ref={scrollRef}
      onMouseDown={mouseDown}
      onMouseLeave={mouseLeave}
      onMouseUp={mouseUp}
      onMouseMove={mouseMove}
    >
      {segments.map((seg) => (
        <button
          key={seg.key}
          className={`seg-btn ${active === seg.key ? "active" : ""}`}
          onClick={() => onChange(seg.key)}
        >
          {seg.label}
        </button>
      ))}
    </div>
  );
}